import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../core/services/utility.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { PortalModulesService } from '../../../core/services/portal-modules.service';
import { HomeService } from '../services/home.service';
import { EventService } from '../../../core/services/event.service';
import moment from 'moment'
import { HotlistModalComponent } from 'src/app/modals/home/hotlist-modal/hotlist-modal.component';
import { OrderByPipe } from './../../../shared/pipe/order-by.pipe';
import { th } from 'date-fns/esm/locale';

@Component({
  selector: 'app-home-index',
  templateUrl: './home-index.component.html',
  styleUrls: ['./home-index.component.css']
})
export class HomeIndexComponent implements OnInit {
  portalSettings: any;
  employeeInfo: any;

  alert: { type: string; msg: string; };
  bulletins: any[];
  bulletinsEnabled: boolean;
  format: string;
  formData: {};
  hidePerformanceAlert: boolean;
  hotlistItems: any[];
  IsTermLock: boolean;
  lastLogonDate: any;
  mobileMode: boolean;
  moduleCategories: any[];
  modules: any;
  passwordResetWarningDays: any;
  performanceAlert: { type: string; msg: string; };
  performanceManAlert: { type: string; msg: string; };
  performanceStatus: any;
  showBulletinAlert: boolean;
  welcomeMsg: any;
  orderByPipe: any;
  performanceManStatus: any;

  constructor(portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private homeService: HomeService, private eventService: EventService, private modalService: NgbModal, private utilityService: UtilityService, private portalModulesService: PortalModulesService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.bulletinsEnabled = this.portalSettings.IsBulletinsEnabled.ConfigValue === "1";
    this.formData = {};
    this.moduleCategories = [];
    this.welcomeMsg = this.portalSettings.PortalWelcomeText.ConfigValue;
    this.passwordResetWarningDays = this.portalSettings.PasswordResetWarningDays.ConfigValue;
    if (this.welcomeMsg != null && this.welcomeMsg != "") {
      this.welcomeMsg = this.welcomeMsg.replace("[firstname]", this.employeeInfo.FirstName);
      this.welcomeMsg = this.welcomeMsg.replace("[lastname]", this.employeeInfo.LastName);
    }

    this.IsTermLock = this.employeeInfo.IsTermLock == 0 ? false : true;
    this.mobileMode = this.utilityService.isMobileMode();
    this.lastLogonDate = null;

    if (this.employeeInfo.UnsignedDocCount > 0)
      this.alert = { type: "danger", msg: "You have " + this.employeeInfo.UnsignedDocCount + " document(s) to review. Click here to go to your document library." };

    if (this.portalSettings.EnableDocLibrary.ConfigValue == 1) {
      this.showBulletinAlert = true;
    } else {
      this.showBulletinAlert = false;
    }

    this.getLastLogonDate();
    this.modules = [];
    this.getModules();
    this.getBulletins();
    this.getCurrentStatus();

  }

  getModules() {
    this.modules = this.portalModulesService.getPortalModules();
    this.getHotlistModules();
    this.groupModules();
  }


  getLastLogonDate() {
    this.homeService.getLastLogonDate().then((response: string) => {
      response as string;
      this.lastLogonDate = response.length < 40 ? response : null;
    });
  }

  routeToDocLibrary() {
    window.location.href = "/Employee/BulletinLibrary"
  }

  //groups and sorts modules
  groupModules() {
    this.moduleCategories = [];

    var temp = [];
    //group modules by category
    this.modules.forEach((module: { ModuleCatgSeq: number; }) => {
      if (module.ModuleCatgSeq != 100) {
        if (temp[module.ModuleCatgSeq] == null) {
          temp[module.ModuleCatgSeq] = [];
        }
        temp[module.ModuleCatgSeq].push(module);
      }
    });
    //remove unused array values
    temp = temp.filter(function (n) { return n != undefined });
    temp.forEach((category, catgKey) => {
      this.moduleCategories[catgKey] = {};
      category.forEach((module: { ModuleCatgName: any; ModuleSubCatgName: any; }) => {
        if (this.moduleCategories[catgKey].CategoryName == null) {
          this.moduleCategories[catgKey].CategoryName = module.ModuleCatgName;
        }
        var subCategory = module.ModuleSubCatgName != null ? module.ModuleSubCatgName : 0;
        if (this.moduleCategories[catgKey][subCategory] == null) {
          this.moduleCategories[catgKey][subCategory] = [];
        }
        this.moduleCategories[catgKey][subCategory].push(module);
      });
    });
    for (let subCatgKey in this.moduleCategories) {
      var subCategory = this.moduleCategories[subCatgKey];
      for (let catgKey in subCategory) {
        var category = subCategory[catgKey];
        if (catgKey != "CategoryName") {
          category.sort(function (a: { ModuleSortSeq: number; }, b: { ModuleSortSeq: number; }) {
            if (a.ModuleSortSeq < b.ModuleSortSeq)
              return -1;
            if (a.ModuleSortSeq > b.ModuleSortSeq)
              return 1;
            return 0;
          });
        }
      }
    }
  }

  getHotlistModules() {
    this.hotlistItems = [];
    var hotlistItems = [];
    this.modules.forEach((module: { IsHotlistItem: any; }) => {
      if (module.IsHotlistItem) {
        hotlistItems.push(module);
      }
    });
    this.hotlistItems = this.orderByPipe.transform(hotlistItems, 'ModulePrettyShortName', 'asc');
  }

  getBulletins() {
    this.homeService.getBulletins('H').then((response: any[]) => {
      this.bulletins = response;
    }).catch((error) => {
      this.bulletins = [];
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  getCurrentStatus() {
    this.homeService.getCurrentStatus().then((response) => {
      this.performanceStatus = response;
      if (this.performanceStatus.length > 0) {
        if (this.performanceStatus[0].DateDue != null)
          this.performanceStatus[0].DateDueDisplay = moment(this.performanceStatus[0].DateDue).utc().format(this.format.toUpperCase());
        this.performanceAlert = { type: "info", msg: "Your performance review process has started and needs your attention by " + this.performanceStatus[0].DateDueDisplay + "!  Click here to continue." };
      }
      this.getManagerGrid();
    });
  }

  getManagerGrid() {
    this.homeService.getManagerGrid().then((response) => {
      this.performanceManStatus = response;
      if (this.performanceManStatus.length > 0) {
        for (var review of this.performanceManStatus) {
          if (review.CanCompleteReview && review.ReviewerIsComplete && review.ConfirmedMgrOn == null && (
            ((review.DisableSelfReview || review.DateCompleted != null) && (review.HasAllManagersCompleted)) ||
            (review.EmployeeChecklistSignedOn == null && !review.DisableSelfReview))) {
            this.performanceManAlert = { type: "info", msg: "You have a performance review ready to finalize! Click here to continue." };
            break;
          }
        }
      }
    });
  }

  routeToForm() {
    window.location.href = "/Performance/Form/#" + this.performanceStatus[0].EmployeeChecklistInstanceID + "/Tab/P/Hide/T/Route/I";
  }

  routeToManForm() {
    window.location.href = "Performance/Index#/Tab=M/Hide=T";
  }

  updateHotlistItem(module: any) {
    this.homeService.setHotlistItem(module).then((response) => {
      this.getHotlistModules();
      this.eventService.broadcast("modulesChanged");
    });
  }

  goToModule(module: { ModuleOpenNewWindow: any; ModuleActionName: string; }) {//open new tab base on module.ModuleOpenNewWindow
    if (module.ModuleOpenNewWindow)
      window.open(module.ModuleActionName);
    else
      window.location.href = module.ModuleActionName;
  }

  editHotList() {
    let modalRef = this.modalService.open(HotlistModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.data = this.moduleCategories;
    modalRef.result.then((result) => {
      this.getHotlistModules();
      this.eventService.broadcast("modulesChanged");
    }).catch(() => { });
  }
}  
